import React, { useEffect, useState } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { CS_ROUTE_KEYS } from 'utils/constants';
import useRoleContext from 'contexts/role.context';
import NewRepModal from './modals/new-rep-modal';
import { apiService } from 'utils/api';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

type ProfileType = 'profile' | 'password' | 'banks' | 'CS reps';

type SettingsListType = {
  title: ProfileType;
  link: string;
};
const SETTINGS_LIST: SettingsListType[] = [
  {
    title: 'profile',
    link: CS_ROUTE_KEYS.PROFILE
  },
  {
    title: 'banks',
    link: CS_ROUTE_KEYS.BANKS
  },
  {
    title: 'CS reps',
    link: CS_ROUTE_KEYS.CS_REPS
  },
  {
    title: 'password',
    link: CS_ROUTE_KEYS.PASSWORD
  }
];

const SettingsLayout = () => {
  const { role } = useRoleContext();
  const isCSSuperAdmin = () => role === ENUM_ROLE.CS_SUPER_ADMIN;
  const isCSRepRoute = () => pathname.includes('cs-reps');

  const [showNewRepModal, setshowNewRepModal] = useState(false);
  const [total, setTotal] = useState(0);

  const toggleModal = () => {
    setshowNewRepModal(!showNewRepModal);
  };

  const getAllReps = async () => {
    try {
      const res = await apiService.get('cs/staff/all', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setTotal(res.data.data.length);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllReps();
  }, []);
  const getHeaderText = () => {
    const headerText: { title: string; details: string } = {
      title: '',
      details: ''
    };

    if (isCSRepRoute()) {
      headerText['title'] = `CS Reps (${total})`;
      headerText['details'] = `Manage CS reps and their roles`;
    } else {
      headerText['title'] = `Settings`;
      headerText['details'] = `Manage your account settings and preferences`;
    }

    return headerText;
  };
  const { pathname } = useLocation();

  const getCsLead = () => {
    return role === ENUM_ROLE.CS_SUPER_ADMIN;
  };

  return (
    <div className={`space-y-12 ${isCSRepRoute() ? 'w-[95%]' : 'w-[80%] max-w-[1000px]'}  `}>
      <div
        className={`py-4 border-b border-[#DCE2EA] ${
          isCSRepRoute() ? 'flex justify-between items-center' : ''
        }`}>
        <div>
          <h1 className='text-lg md:text-2xl font-semibold'> {getHeaderText().title}</h1>
          <p className='text-gray-5 text-sm'>{getHeaderText().details}</p>
        </div>
        {isCSRepRoute() && isCSSuperAdmin() && (
          <Button
            onClick={toggleModal}
            color='primary'
            variant='block'
            className='w-[130px] text-sm'
            small>
            <AddIcon />
            Add new
          </Button>
        )}
      </div>
      <div className='flex items-start gap-5'>
        <ul className='flex flex-col gap-4 w-[25%] max-w-[250px]'>
          {SETTINGS_LIST.map(({ title, link }, i) => (
            <Link
              to={link}
              className={`capitalize text-xs py-1 pl-4 cursor-pointer transition-all duration-100 ${
                pathname.includes(link) ? 'border-l-2 text-gray-6' : 'text-gray-5'
              } ${!getCsLead() && title === 'CS reps' ? 'hidden' : ''}`}
              key={i}>
              {title}
            </Link>
          ))}
        </ul>
        {showNewRepModal && <NewRepModal show={showNewRepModal} onClose={toggleModal} />}

        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;
